import { PermissionsState } from '@core/permissions/store/states/permissions.state';

export const permissionsState = [PermissionsState];
